module.exports = __webpack_public_path__ + "static/media/ic-callkit-audio-off.e6d9e93c.webp";